module.exports = __webpack_public_path__ + "img/02_sp.83ff3890.jpg";